"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

var _content;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : CONTROLS : CONTROL : STYLES --------------- ++++++++++ */


var _default = {
  cardcontrol: {
    minHeight: (0, _index.pxToEm)(128),
    minWidth: (0, _index.pxToEm)(480),
    width: '100%',
    border: "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.neutral.light.swatch, " solid"),
    display: 'flex',
    cursor: 'pointer',
    transition: 'filter .15s ease-in 0s',
    borderRadius: (0, _index.pxToEm)(12),
    marginBottom: (0, _index.pxToEm)(8),
    '&:hover': {
      filter: 'brightness(83%)'
    },
    '&:last-child': {
      marginBottom: '0px'
    },
    '& .imgcontent': {
      minWidth: (0, _index.pxToEm)(64),
      height: '100%',
      margin: (0, _index.replacePXinStringWithEM)('16px 16px 64px 24px'),
      '& img': {
        width: (0, _index.pxToEm)(64),
        height: (0, _index.pxToEm)(64),
        borderRadius: (0, _index.pxToEm)(32),
        backgroundColor: 'rgba(129, 201, 255, 0.09)'
      }
    },
    '& .content': (_content = {
      width: '100%',
      height: '100%',
      alignSelf: 'right',
      padding: (0, _index.replacePXinStringWithEM)('16px 24px 16px 0px'),
      display: 'block',
      position: 'relative'
    }, _defineProperty(_content, "height", '100%'), _defineProperty(_content, "zIndex", 5), _defineProperty(_content, '& .title', {
      lineHeight: (0, _index.pxToEm)(24),
      display: 'flex',
      marginBottom: (0, _index.pxToEm)(8),
      '& span': {
        color: function color(props) {
          return props.selected ? _index.theme.color.primary.medium.swatch : _index.theme.color.supporting.dark.swatch;
        },
        fontSize: '16px',
        fontWeight: 'regularbold'
      },
      '& .recommended': {
        display: function display(props) {
          return props.recommended ? 'block' : 'none';
        },
        marginLeft: (0, _index.pxToEm)(8),
        color: '#c0c9dc',
        fontSize: (0, _index.pxToEm)(14),
        fontWeight: 'regular'
      }
    }), _defineProperty(_content, '& .description', {
      color: _index.theme.color.supporting.xlight.swatch,
      fontSize: (0, _index.pxToEm)(14),
      fontWeight: 'normal',
      marginBottom: (0, _index.pxToEm)(8)
    }), _defineProperty(_content, '& .tips', {
      display: function display(props) {
        return !!props.tips ? 'block' : 'none';
      },
      color: '#c0c9dc',
      fontSize: (0, _index.pxToEm)(14),
      fontWeight: 'normal',
      lineHeight: (0, _index.pxToEm)(24)
    }), _content),
    '& .trianglecontainer': {
      width: (0, _index.pxToEm)(24),
      display: function display(props) {
        return props.selected ? 'block' : 'none';
      },
      '& .triangle': {
        width: (0, _index.pxToEm)(56),
        height: (0, _index.pxToEm)(56),
        border: "".concat((0, _index.pxToEm)(28), " solid"),
        borderRadius: (0, _index.replacePXinStringWithEM)('0px 12px 0px 0px'),
        borderColor: function borderColor(props) {
          return props.selected ? "".concat(_index.theme.color.primary.medium.swatch, " ").concat(_index.theme.color.primary.medium.swatch, " transparent transparent") : "".concat(_index.theme.color.light.light.swatch, " ").concat(_index.theme.color.light.light.swatch, " transparent transparent");
        },
        marginLeft: 'auto',
        position: 'relative',
        zIndex: 3,
        top: '-1px',
        right: '31.25px',
        '& .icon': {
          width: '16px',
          height: '16px',
          fontSize: '12px',
          position: 'relative',
          color: _index.theme.color.light.light.swatch,
          top: '-22px',
          right: '-5px',
          zIndex: 4
        }
      }
    },
    '&.selected-true': {
      color: _index.theme.color.primary.medium.swatch,
      boxShadow: _index.theme.boxShadow.inset,
      border: "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.primary.medium.swatch, " solid"),
      backgroundColor: 'rgba(129, 201, 255, 0.09)',
      '&:hover': {
        filter: 'brightness(98%)'
      }
    }
  }
};
exports.default = _default;